module.exports = __webpack_public_path__ + "static/media/438237622_1787506601754819_3556428105215936214_n.20957741.jpg";